import { Assert } from '@team/assert';
import { HEAD_ELEMENT_INDEX } from './const.js';

export function isHeadElement(index: number) {
  return Assert.isEquals(HEAD_ELEMENT_INDEX, index);
}
